<template>
  <MaskModel :maskShow="maskShow" :width="700" @on-cancel="cancel">
    <div class="sign-project">
      <div class="title">签到</div>
      <div class="content-box">
        <div class="sum-integral">
          <span>总积分：{{ parseInt(userInfo.integral) }}</span>
        </div>
        <div class="date-list">
          <div class="wrapper">
            <div
              class="item"
              v-for="(item, index) of signSystemList"
              :key="item.id"
            >
              <div
                class="day"
                :class="index + 1 === signSystemList.length ? 'rewordtext' : ''"
              >
                {{ item.day }}
              </div>
              <div
                class="bg-image"
                :class="[
                  sign_index >= index + 1 ? 'venusSelect' : '',
                  index + 1 === signSystemList.length ? 'reword' : ''
                ]"
              ></div>
              <div class="num" :class="sign_index >= index + 1 ? 'on' : ''">
                +{{ item.sign_num }}
              </div>
            </div>
          </div>
          <div
            class="btn"
            :class="userInfo.is_day_sgin ? 'on' : ''"
            @click="goSign"
          >
            {{ userInfo.is_day_sgin ? "已签到" : "立即签到" }}
          </div>
        </div>
        <div class="sum-day">
          <div class="tip">已累计签到</div>
          <div class="sum-day-list">
            <div class="item" v-for="(item, index) of signCount" :key="index">
              {{ item }}
            </div>
          </div>
          <div class="tip2">
            据说连续签到第{{ day }}天可获得超额积分，一定要坚持签到哦~~~
          </div>
        </div>
      </div>
    </div>
    <div class="signTip" :hidden="active === false">
      <div class="signTipLight"></div>
      <div class="signTipCon">
        <div class="state">签到成功</div>
        <div class="integral">获得{{ integral }}积分</div>
        <div class="signTipBnt" @click="close">好的</div>
      </div>
    </div>
    <div class="mask-sign" :hidden="active === false"></div>
  </MaskModel>
</template>

<script>
import MaskModel from "@/components/pc/MaskModel";
import { add } from "@/utils/bc";
import { getSignConfig, postSignUser, postSignIntegral } from "@api/user";
export default {
  name: "SignIn",
  components: {
    MaskModel
  },
  data() {
    return {
      maskShow: false,
      userInfo: {},
      integral: 0,
      signCount: [],
      sign_index: 0,
      signSystemList: [],
      day: "",
      active: false
    };
  },
  methods: {
    // js给数字补0；num：需要补0的数字，length：长度（补到多少位）；
    PrefixInteger(num, length) {
      return (Array(length).join("0") + num).slice(-length).split("");
    },
    // 数字转中文
    Rp(n) {
      var cnum = ["零", "一", "二", "三", "四", "五", "六", "七", "八", "九"];
      var s = "";
      n = "" + n; // 数字转为字符串
      for (var i = 0; i < n.length; i++) {
        s += cnum[parseInt(n.charAt(i))];
      }
      return s;
    },
    cancel() {
      this.maskShow = false;
    },
    sign() {
      this.maskShow = true;
      this.signUser();
      this.getSignConfigList();
    },
    getSignConfigList() {
      getSignConfig()
        .then(res => {
          if (res.status === 200) {
            this.signSystemList = res.data;
            this.day = this.Rp(this.signSystemList.length);
          }
        })
        .catch(err => {
          console.log(err.msg);
        });
    },
    signUser() {
      postSignUser({ sign: 1 })
        .then(res => {
          var sumSginDay = res.data.sum_sgin_day;
          this.userInfo = res.data;
          this.signCount = this.PrefixInteger(sumSginDay, 4);
          this.sign_index = parseInt(res.data.sign_num);
        })
        .catch(err => {
          this.maskShow = false;
          console.log(err.msg);
        });
    },
    goSign() {
      const sumSginDay = this.userInfo.sum_sgin_day;
      if (this.userInfo.is_day_sgin) {
        this.$Message.error("您今日已签到!");
        return;
      }
      postSignIntegral()
        .then(res => {
          this.active = true;
          this.integral = res.data.integral;
          const signIndex = parseInt(this.sign_index + 1);
          this.sign_index =
            signIndex > this.signSystemList.length ? 1 : signIndex;
          this.signCount = this.PrefixInteger(sumSginDay + 1, 4);
          this.userInfo.is_day_sgin = true;
          this.userInfo.integral = add(
            this.userInfo.integral,
            res.data.integral
          );
        })
        .catch(err => {
          console.log(err.msg);
        });
    },
    close() {
      this.active = false;
    }
  }
};
</script>

<style lang="stylus" scoped>
.sign-project
  .title
    font-size 14px
    padding-bottom 5px
    border-bottom 1px dashed #ccc
  .content-box
    margin-top 15px
    .sum-integral
      span
        background #ff9000
        padding 8px
        border-radius 4px
        color #fff
    .date-list
      margin-top 20px
      border 1px solid #cccccc
      border-radius 5px
      padding 5px
      .wrapper
        .item
          display inline-block
          width 12%
          color #8a8886
          .day
            line-height 26px
            font-size 11px
            &.rewordtext
              background #f4b409
              color #fff
              margin 0 8px
              border-radius 10px
          .bg-image
            margin 0 auto
            width 30px
            height 30px
            background-image url('../../../assets/pc/images/nav/stars2.png')
            background-repeat no-repeat
            background-size 100% 100%
            background-position center center
            &.venusSelect
              background-image url('../../../assets/pc/images/nav/stars1.png')
            &.reword
              background-image url('../../../assets/pc/images/nav/stars3.png')
          .num
            line-height 26px
            font-size 16px
            &.on
              color #ff9000
      .btn
        cursor pointer
        margin 30px auto 10px
        width 200px
        line-height 30px
        border-radius 50px
        background #e93323
        color #fff
        font-size 14px
        &.on
          background #999
    .sum-day
      margin-top 10px
      .sum-day-list
        margin-top 10px
        margin-bottom 10px
        position relative
        .item
          display inline-block
          width 50px
          height 80px
          background url('../../../assets/pc/images/nav/redBg.png') no-repeat
          background-size 100% 100%
          margin-right 10px
          color #ffffff
          font-size 60px
          line-height 80px
        &:after
          content '天'
          display inline-block
          font-size 16px
          position absolute
          bottom 3px
      .tip2
        line-height 30px
        color #999
        font-size 14px
.signTip
  width: 300px;
  height: 300px;
  position: fixed;
  top: 50%;
  left: 50%;
  margin-left: -150px;
  margin-top: -150px;
  z-index: 99;
  text-align: center;
  .signTipLight
    width 100%
    height 100%
    background-image url('../../../assets/pc/images/nav/light.png')
    background-repeat no-repeat
    background-size 100% 100%
    animation load 3s linear 1s infinite;
  .signTipCon
    width 250px
    height 250px
    position absolute
    top: 10px;
    left: 25px;
    background-image url('../../../assets/pc/images/nav/register.png')
    background-size 100% 100%
    background-repeat no-repeat
    .state
      margin-top 100px
      color #ffffff
      font-size 18px
    .integral
      margin-top 10px
      color hsla(0,0%,100%,.6)
      font-size 16px
    .signTipBnt
      cursor pointer
      font-size: 16px;
      color: #eb4331;
      width: 120px;
      height: 30px;
      background-color: #f8d168;
      border-radius: 15px;
      line-height: 30px;
      margin: 20px auto 0 auto;
.mask-sign
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 55;
  background-color: rgba(0,0,0,.5);
@-webkit-keyframes load
  0%
    transform rotate(0deg)
  100%
    transform rotate(360deg)
</style>
